// src/pages/SellerIntelligence/components/FeatureCardGrid.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from '../SellerIntelligence.module.css';

// Card grid shared by every Seller Intelligence index page. An item carrying a
// route renders as a button and navigates. An item without one renders as a
// static card, so a feature can be listed before it is built without offering a
// click that leads nowhere.
const FeatureCardGrid = ({ items }) => {
  const navigate = useNavigate();

  return (
    <div className={styles.cardGrid}>
      {items.map(({ id, title, description, icon, route, note, action }) => {
        const isLink = Boolean(route);
        const body = (
          <>
            <div className={styles.cardIcon}>{icon}</div>
            <h3 className={styles.cardTitle}>{title}</h3>
            <p className={styles.cardDescription}>{description}</p>
            {note && <span className={styles.cardNote}>{note}</span>}
            <span className={isLink ? styles.cardAction : styles.cardPending}>
              {isLink ? (action || 'View →') : 'Not built yet'}
            </span>
          </>
        );

        return isLink ? (
          <button
            key={id}
            type="button"
            className={styles.toolCard}
            onClick={() => navigate(route)}
          >
            {body}
          </button>
        ) : (
          <div key={id} className={`${styles.toolCard} ${styles.staticCard}`}>
            {body}
          </div>
        );
      })}
    </div>
  );
};

export default FeatureCardGrid;
